import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { Form } from "./Form";
import { Table } from "./Table";
import useToggle from "../../hooks/useToggle";
import { ILead } from "../../models/BaseModel";
import { LeadHistory } from "../lead/History";
import { Itinerary } from "./Itinerary";
import { UpdateInvoiceRate } from "./UpdateInvoive";
import { TransferHistory } from "./TransferHistory";

export interface IOpenForm {
    open: boolean,
    singleData: ILead,
    type: 'none' | 'change_status_form' | 'status_h' | 'transfer_h' | 'itinerary' | 'update_invoice'
}

export const MyLead = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [modal, setModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false, type: 'none' });
    }

    return (
        <>
            {hasPermission("MyLead", "Edit") && <Form hasPermission={hasPermission} singleData={modal.singleData} open={modal.open && modal.type === 'change_status_form'} hideDialog={hideDialog} toast={toast} reloadData={reloadData}></Form>}
            {hasPermission("MyLead", "History") && <LeadHistory hasPermission={hasPermission} singleData={modal.singleData} open={modal.open && modal.type === 'status_h'} hideDialog={hideDialog} toast={toast}></LeadHistory>}
            {hasPermission("MyLead", "Itinerary") && <Itinerary toast={toast} singleData={modal.singleData} open={modal.open && modal.type === 'itinerary'} hideDialog={hideDialog} ></Itinerary>}
            <UpdateInvoiceRate toast={toast} singleData={modal.singleData} open={modal.open && modal.type === 'update_invoice'} hideDialog={hideDialog} ></UpdateInvoiceRate>
            <TransferHistory hasPermission={hasPermission} singleData={modal.singleData} open={modal.open && modal.type === 'transfer_h'} hideDialog={hideDialog} toast={toast} reloadData={reloadData} />
            <Table hasPermission={hasPermission} setModal={setModal} toast={toast} reload={reload} reloadData={reloadData}></Table>
            <Toast ref={toast} />
        </>
    );
}
